export const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const CROPPER_ZOOM_MIN = 0.5;
export const CROPPER_ZOOM_MAX = 1.5;
